import woothee from "woothee";

const ua = woothee.parse(window.navigator.userAgent);
export default {
  isPc: ua.category === "pc",
  users: [],
};
